import { createStore } from "vuex";

export default createStore({
  state: {
    estateAmount: 10000,
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
